// extracted by mini-css-extract-plugin
export default {"container":"ChekQR_container__A1QJE","content":"ChekQR_content__Sl50Y"};